import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  ViewChild,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { FormGroup } from '@angular/forms/src/model';
import {
  TableColumn,
  ColumnMode,
  SelectionType
} from '@swimlane/ngx-datatable';

import { FamilleRechercheModel } from '../models/famille-recherche.model';
import {
  TableMode,
  FormGeneratorService,
  TableEvent,
  StoreService
} from '@ngx-resource-toolkit/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';

import { SettingsService } from '../../../core/settings/settings.service';
import { TabsService } from '../../services/tabs.service';
import { FamilleModel } from '../models/famille.model';
import { ExportService } from '../../services/export.service';
import { FamilleService } from '../../services/famille.service';
import { ModalConfirmationComponent } from '../../miscellaneous/modal-confirmation.component';
import { FamilleActions } from '../models/famille.store';

import { Subscription } from 'rxjs/Subscription';
import { ErrorMessageService } from '../../services/error-message.service';
import { ObjetLight } from '../../objetLight/models/ObjetLight';
import { TableButtonsService } from '../../services/table-buttons.service';
import { BaseTableSizeComponent } from '../../components/base-table-size.component';

@Component({
  selector: 'app-famille',
  animations: [
    trigger('visibilityChanged', [
      state('shown', style({ display: 'block', height: '*' })),
      state('hidden', style({ display: 'none', height: 0 })),
      transition('hidden => shown', animate('0.5s'))
    ])
  ],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FamilleComponent extends BaseTableSizeComponent implements OnInit, OnDestroy, AfterViewInit {
  TableMode = TableMode;
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  @ViewChild(ModalConfirmationComponent)

  @Input() public isSingleSelectAndClose: Boolean = false;
  @Input() public selectionType = SelectionType.multiClick;
  @Output() familleSelected: EventEmitter<ObjetLight> = new EventEmitter<ObjetLight>();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  modalConfirmation: any;
  public confirmationEvent: TableEvent;
  public confirmationMessage: string;

  public listModel: FamilleModel;
  public list: FamilleModel[];
  public searchModel: FamilleRechercheModel;
  public searchForm: FormGroup;
  public tableButtons: any[];

  public selected: Array<ObjetLight> = [];
  @Input() public selectedFamilles: Array<FamilleModel> = [];
  public editing: boolean[] = Array<boolean>();
  public selectedAction: string;
  public visibility = 'hidden';
  public limit = 10;

  public searchRows: any[] = new Array<any>();
  public searchColumns: TableColumn[] = new Array<TableColumn>();

  public storeSub: Subscription = null;
  public loading: boolean = false;
  public exportLoading: boolean = false;

  constructor(
    private exportService: ExportService,
    private tabsService: TabsService,
    private settings: SettingsService,
    private toaster: ToasterService,
    private http: HttpClient,
    private router: Router,
    private errorMessages: ErrorMessageService,
    private store: StoreService,
    private formGenerator: FormGeneratorService,
    private buttonsService: TableButtonsService,
  ) {
    super();
    this.list = [];
    this.listModel = new FamilleModel({});

    this.searchModel = new FamilleRechercheModel();
    this.searchModel.anneeScolaire = this.settings.getUserSetting(
      'anneeScolaire'
    );
    this.searchForm = formGenerator.createFormGroup(this.searchModel, 'search');
  }

  ngOnInit(): void {
    console.log({ ou: 'ngOnInit', isSingleSelectAndClose: this.isSingleSelectAndClose });
    super.ngOnInit();

    this.limit = this.settings.getUserSetting('list.limit');
    this.tableButtons = this.buttonsService.buildButtons('FAMILLE');
    this.storeSub = this.store
      .getState(etat => etat.famille)
      .subscribe(etat => {
        if (etat.searchForm) {
          this.searchForm = etat.searchForm;
        }
        if (etat.list instanceof Array) {
          this.list = etat.list.map(famille => new FamilleModel(famille))
            .filter((f, i, tab)=>i==0 || tab[i-1].id!=f.id); // Les familles sont triées, permet de supprimer les doublons de famille (ccas ou il y a plusieurs responsables principaux)
        } else {
          this.list = [];
        }
        this.loading = etat.loading;
      });
    this.majColonnesAffichees();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.storeSub.unsubscribe();
  }

  ngAfterViewInit() {
    this.pageReady.next(true);
  }

  selectionChanged(famillesSelectionnees) {
    // console.log('selectionChanged', famillesSelectionnees);
    this.selected = famillesSelectionnees;
    // Mise à jour de la sélection dans le tableau
    this.selectedFamilles = [];
    this.selected.forEach(element => {
      // element.id
      const elementSelectionne = this.list.find(function (cur: FamilleModel) {
        return +cur.id === element.id;
      });
      this.selectedFamilles.push(elementSelectionne);
    });
    // console.log('selected', this.selected, 'famillesSelectionnees', famillesSelectionnees);
  }

  /**
   * Sélectionne toutes les familles.
   */
  selectedAll() {
    this.selected.splice(0, this.selected.length);
    this.selected = this.listFamilleToListObjetLight(this.list);
    this.selectedFamilles = this.list;
  }

  /**
   * Met à jour les colonnes afffichées en fonction du contexte (critères saisis)
   */
  majColonnesAffichees() {
    // Afficher la colonne siolde si 'AvecTropPerçu' ou avecDette ou sansPaiement coché
    const colonneSoldeAffichee = this.searchForm.value['isFamilleAvecTropPercu']
      || this.searchForm.value['isFamilleAvecDette']
      || this.searchForm.value['isFamilleSansPaiement'];
    this.listModel.registerEntriesDynamicProperties(['table'], {
      solde: { hidden: !colonneSoldeAffichee },
    });
    this.tableButtons = this.isSingleSelectAndClose ? [] : this.buttonsService.buildButtons('FAMILLE');

  }

  search() {
    this.store.dispatch(
      FamilleActions.search({
        http: this.http,
        model: this.searchModel,
        form: this.searchForm,
        params: [
          this.searchForm.controls['id'].value,
          this.settings.getUserSetting('anneeScolaire')
        ],
        errorCallback: err => {
          console.log('FamilleSearchComponent', 'search error', err);
          this.toaster.pop(
            'error',
            'Erreur lors de la recherche de famille (FamilleSearchComponent)'
          );
        }
      })
    );
    this.majColonnesAffichees();
  }

  exportWrapper(method: string, filenameOnDisk: string) {
    this.exportLoading = true;
    const callback = function(component) { component.exportLoading = false; };
    this.exportService.exportWrapper(
      this.searchModel,
      this.searchForm.value,
      method,
      filenameOnDisk,
      [],
      null,
      callback,
      this
    );
  }

  reset() {
    this.store.dispatch(
      FamilleActions.clearSearch({
        errorCallback: err => {
          console.log('FamilleClearSearch', 'Clear search error', err);
          this.toaster.pop(
            'error',
            'Erreur lors de la réinitialisation des critères de recherche de famille (FamilleSearchComponent)'
          );
        }
      })
    );
    this.searchForm.reset();
    this.searchForm = this.formGenerator.createFormGroup(
      this.searchModel,
      'search'
    );
    this.list = [];
  }

  private listFamilleToListObjetLight(listFamille: Array<FamilleModel>) {
    const listeLightObject: Array<ObjetLight> = [];
    listFamille.forEach(element => {
      const objSel: ObjetLight = new ObjetLight({
        id: element.id,
        libelle: element.nom,
        typeObjet: 'F'
      });
      listeLightObject.push(objSel);
    });
    return listeLightObject;
  }
  onSelect(selected) {
    console.log('FamilleComponent', 'Select Event', selected, this.selected);
    if (selected != null) {
      this.selected.splice(0, this.selected.length);
      /*selected.forEach(element => {
                const objSel: ObjetLight = new ObjetLight({id: element.id, libelle: element.nom, typeObjet: 'F'});
                this.selected.push(objSel);
            });*/
      this.selected = this.listFamilleToListObjetLight(selected);

      if (this.isSingleSelectAndClose) {
        // On renvoie la famille sélectionnée et on ferme la fenêtre de recherche
        this.familleSelected.emit(this.selected[0]);
        this.reset(); // Pour réinitialiser les critères de recherche pour la prochaine recherche
        return;
      }

    } else {
      this.selected = [];
    }
  }

  toggleActions(event) {
    this.visibility === 'shown'
      ? (this.visibility = 'hidden')
      : (this.visibility = 'shown');
  }

  onEdit(data: TableEvent) {
    console.log('FamilleComponent', 'Edit Event', data, data.row.id);

    // Vidage cache pour forcer rechargement
    this.store.dispatch(
      FamilleActions.clear({
        id: data.row.id,
        errorCallback: err => {
          console.log('FamilleSearchComponent', 'clear error', err);
          this.toaster.pop('error', 'Erreur lors du vidage de la famille');
        }
      })
    );
    this.router.navigate(['/famille/edit', data.row.id]);

    this.tabsService.addTab({
      label: `${data.row.nom} (${data.row.id})`,
      link: '/famille/edit/' + data.row.id,
      group: 'famille',
      iconClass: 'fa fa-edit'
    });
  }

  onAddRow(data: TableEvent) {
    console.log('FamilleComponent', 'Add row Event', data);
  }

  onConsult(data: TableEvent) {
    console.log('FamilleComponent', 'Consult Event', data);

    // Vidage cache pour forcer rechargement
    this.store.dispatch(
      FamilleActions.clear({
        id: data.row.id,
        errorCallback: err => {
          console.log('FamilleSearchComponent', 'clear error', err);
          this.toaster.pop('error', 'Erreur lors du vidage de la famille');
        }
      })
    );

    this.router.navigate(['/famille/show', data.row.id]);

    this.tabsService.addTab({
      label: `${data.row.nom} (${data.row.id})`,
      link: '/famille/show/' + data.row.id,
      group: 'famille',
      iconClass: 'fa fa-user'
    });
  }

  onDelete(event: TableEvent) {
    this.confirmationEvent = event;
    this.confirmationMessage = `Voulez-vous supprimer la famille ${
      event.row.nom
      } (${event.row.id}) ?`;
    this.modalConfirmation.modal.open();
  }

  deleteFamille(event: TableEvent) {
    this.store.dispatch(
      FamilleActions.delete({
        http: this.http,
        model: event.row,
        successCallback: data => {
          if (data > 0) {
            this.tabsService.removeTab({ link: this.router.url, group: 'famille' });
          } else {
            this.toaster.pop(
              'error',
              this.errorMessages.getFamilleDeleteMessage(data)
            );
          }
          this.modalConfirmation.modal.close();
        },
        errorCallback: error => {
          this.modalConfirmation.modal.close();
          console.log('FamilleComponent', 'deleteFamille error', error);
          this.toaster.pop(
            'error',
            'Erreur lors de la suppression d\'une famille'
          );
        }
      })
    );
  }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/famille/search/search.component.ts